import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";

const BalanceValueBonusAndCashDefaultBox = styled.div`
    font-size: inherit;
    letter-spacing: inherit;
    font-size: 1.4rem;
    color: ${({theme}) => theme.colors.textLight};
`;

const BalanceValueBonusAndCashCasino777Box = styled(BalanceValueBonusAndCashDefaultBox)`
    color: ${({theme}) => theme.colors.moneyColor};
`;

const BalanceValueBonusAndCashHarrahsWsopBox = styled(BalanceValueBonusAndCashDefaultBox)`
    ${({theme}) => theme.font.presets.body}
`;

export const BalanceValueBonusAndCashBox = styledByTheme(BalanceValueBonusAndCashDefaultBox)
    .forCasino777(BalanceValueBonusAndCashCasino777Box)
    .forHarrahs(BalanceValueBonusAndCashHarrahsWsopBox)
    .forWsop(BalanceValueBonusAndCashHarrahsWsopBox)
    .apply();
